import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['panel', 'button']
  static values = { flip: Boolean }

  connect () {
    this.repositionHandler = this.placePanel.bind(this)
    this.handleClickOutside = (event) => {
      if (!this.element.contains(event.target)) this.close()
    }
    this.handleKeydown = (event) => {
      if (event.key === 'Escape') this.close()
    }
    this.handleCloseAll = (event) => {
      if (event.detail?.except !== this) this.close()
    }
    document.addEventListener('dropdown:close-all', this.handleCloseAll)
  }

  disconnect () {
    this.elevateRow(false)
    this.removeListeners()
    if (this.flipValue) {
      window.removeEventListener('scroll', this.repositionHandler, true)
      window.removeEventListener('resize', this.repositionHandler)
    }
    document.removeEventListener('dropdown:close-all', this.handleCloseAll)
  }

  toggle (event) {
    event.stopPropagation()
    if (this.panelTarget.classList.contains('hidden')) {
      this.open()
    } else {
      this.close()
    }
  }

  open () {
    document.dispatchEvent(new CustomEvent('dropdown:close-all', { detail: { except: this } }))
    this.elevateRow(true)
    this.panelTarget.classList.remove('hidden')
    if (this.flipValue) {
      this.placePanel()
      window.addEventListener('scroll', this.repositionHandler, true)
      window.addEventListener('resize', this.repositionHandler)
    }
    this.buttonTarget.setAttribute('aria-expanded', 'true')
    window.setTimeout(() => {
      document.addEventListener('click', this.handleClickOutside)
      document.addEventListener('keydown', this.handleKeydown)
    }, 0)
  }

  close () {
    if (this.panelTarget.classList.contains('hidden')) return

    this.panelTarget.classList.add('hidden')
    this.buttonTarget.setAttribute('aria-expanded', 'false')
    this.elevateRow(false)
    this.removeListeners()
    if (this.flipValue) {
      window.removeEventListener('scroll', this.repositionHandler, true)
      window.removeEventListener('resize', this.repositionHandler)
      this.resetPanelPlacement()
    }
  }

  removeListeners () {
    document.removeEventListener('click', this.handleClickOutside)
    document.removeEventListener('keydown', this.handleKeydown)
  }

  placePanel () {
    this.panelTarget.classList.remove('top-full', 'mt-2', 'bottom-full', 'mb-2')

    const buttonRect = this.buttonTarget.getBoundingClientRect()
    const panelHeight = this.panelTarget.offsetHeight
    const gap = 8
    const spaceBelow = window.innerHeight - buttonRect.bottom - gap
    const spaceAbove = buttonRect.top - gap
    const openAbove = panelHeight > spaceBelow && spaceAbove > spaceBelow

    if (openAbove) {
      this.panelTarget.classList.add('bottom-full', 'mb-2')
    } else {
      this.panelTarget.classList.add('top-full', 'mt-2')
    }
  }

  resetPanelPlacement () {
    this.panelTarget.classList.remove('bottom-full', 'mb-2')
    this.panelTarget.classList.add('top-full', 'mt-2')
  }

  elevateRow (elevated) {
    const row = this.element.closest('li')
    if (!row) return

    row.classList.toggle('z-50', elevated)
  }
}
